import { render, staticRenderFns } from "./survey.component.vue?vue&type=template&id=10d70d8e&scoped=true&"
import script from "./survey.component.vue?vue&type=script&lang=ts&"
export * from "./survey.component.vue?vue&type=script&lang=ts&"
import style0 from "./survey.component.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./survey.component.vue?vue&type=style&index=1&id=10d70d8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d70d8e",
  null
  
)

export default component.exports